import styled from 'styled-components';

const SwitchLoader = styled.div`
&.loader {
  width: 30px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 4px solid var(--borderLightColor);
  border-right-color: var(--secondary);
  animation: l2 1.5s infinite linear;
}
@keyframes l2 {to{transform: rotate(1turn)}}
`;
export {
	SwitchLoader
};